import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@saesa/ui-kit-front';
import { TipoColorLineaAvanceEnum } from 'config';
import {
  ALTO_ICONO_VOLVER,
  ANCHO_ICONO_VOLVER,
  VARIABLE_LINEA_ALTO,
  VARIABLE_LINEA_COLOR,
  VARIABLE_LINEA_TOP,
} from './outageDashboard.constants';

/**
 * Tokens Figma timeline 8854:111395 — Title-S 18/26, Body-L 16/24
 */
const DetalleAvanceStyles = makeStyles(() =>
  createStyles({
    capa: {
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      borderRadius: 20,
      boxSizing: 'border-box',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        inset: 'auto',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        height: '100%',
        minHeight: 0,
        flex: '1 1 auto',
        borderRadius: 0,
        overflow: 'hidden',
        boxShadow: 'none',
        zIndex: 1,
      },
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      /**
       * X modal: top 24 + icono 24 centrado en hit 32 → centro ~40.
       * paddingTop 32 alinea el glifo del título (16/24) con ese centro.
       */
      padding: '32px 37px 8px 37px',
      flexShrink: 0,
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        backgroundColor: '#FFFFFF',
        /**
         * Mobile: 24px arriba, 21px izquierda; derecha deja hueco para la X
         */
        padding: '24px 48px 12px 21px',
      },
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      minWidth: 0,
    },
    botonVolver: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 14,
      background: 'none',
      border: 'none',
      padding: 0,
      margin: 0,
      cursor: 'pointer',
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      color: '#4F1FFF',
      textDecoration: 'none',
      userSelect: 'none',
      /**
       * Patrón textoLink (ModalGlobalStyles): hover sin underline
       */
      '&:hover': {
        color: '#2700B8',
        textDecoration: 'none',
      },
      '&:focus': {
        textDecoration: 'none',
      },
      '&:focus-visible': {
        outline: '2px solid #4F1FFF',
        outlineOffset: 2,
        borderRadius: 2,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        lineHeight: '18px',
        gap: 8,
      },
    },
    iconoVolver: {
      width: ANCHO_ICONO_VOLVER,
      height: ALTO_ICONO_VOLVER,
      display: 'block',
      flexShrink: 0,
    },
    cuerpo: {
      flex: '1 1 auto',
      minHeight: 0,
      /**
       * Desktop: sin barra de scroll (el modal acomoda el detalle)
       */
      overflowY: 'hidden',
      overflowX: 'hidden',
      padding: '16px 37px 24px',
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        /**
         * 21px laterales → bolas y textos alineados al padding del header
         */
        padding: '8px 21px 16px',
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
      },
    },
    timeline: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 640,
      width: '100%',
      minWidth: 0,
      position: 'relative',
      paddingBottom: 16,
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        width: '100%',
        paddingBottom: 8,
      },
    },
    timelineCorto: {
      maxWidth: 640,
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },
    /**
     * Capa absoluta: tramos medidos entre centros de bolas
     */
    lineasLayer: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: 40,
      height: '100%',
      pointerEvents: 'none',
      zIndex: 0,
    },
    lineaSeg: {
      position: 'absolute',
      left: '50%',
      top: `var(${VARIABLE_LINEA_TOP})`,
      height: `var(${VARIABLE_LINEA_ALTO})`,
      backgroundColor: `var(${VARIABLE_LINEA_COLOR})`,
      transform: 'translateX(-50%)',
      width: 3,
      borderRadius: 0,
      zIndex: 0,
    },
    paso: {
      display: 'grid',
      gridTemplateColumns: '40px minmax(0, 1fr)',
      columnGap: 24,
      alignItems: 'start',
      position: 'relative',
      zIndex: 1,
      minWidth: 0,
      width: '100%',
    },
    /**
     * Separación entre etapas: la da `colTexto` (paddingBottom 32).
     * La igualdad de tramos de línea se aplica en JS (minHeight al máximo).
     */
    pasoConSeparacion: {
      boxSizing: 'border-box',
    },
    colIndicador: {
      width: 40,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    /**
     * Reserva fija para que el nodo quede a la misma altura en cada paso
     */
    horaSpacer: {
      width: '100%',
      height: 30,
      flex: '0 0 30px',
    },
    nodoSlot: {
      position: 'relative',
      zIndex: 2,
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      flexShrink: 0,
    },
    nodoDone: {
      width: 20,
      height: 20,
      borderRadius: '50%',
      backgroundColor: TipoColorLineaAvanceEnum.IMPREVISTO,
      flexShrink: 0,
      display: 'block',
      position: 'relative',
      zIndex: 2,
    },
    nodoDoneNaranja: {
      backgroundColor: '#E08A00',
    },
    nodoCircle: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      position: 'relative',
      zIndex: 2,
    },
    nodoActive: {
      backgroundColor: TipoColorLineaAvanceEnum.IMPREVISTO,
    },
    nodoPending: {
      backgroundColor: TipoColorLineaAvanceEnum.PENDIENTE,
    },
    nodoActiveGreen: {
      backgroundColor: TipoColorLineaAvanceEnum.NORMALIZADO,
    },
    nodoActiveNaranja: {
      backgroundColor: '#E08A00',
    },
    nodoActiveAzul: {
      backgroundColor: TipoColorLineaAvanceEnum.FUTURO,
    },
    nodoDoneGreen: {
      backgroundColor: TipoColorLineaAvanceEnum.NORMALIZADO,
    },
    iconoNodo: {
      width: 22,
      height: 22,
      display: 'block',
    },
    /**
     * Textos: hora · título · subtítulo con 4px entre cada uno.
     * paddingBottom 32 = distancia real entre el fin de un texto y el inicio del siguiente.
     */
    colTexto: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      paddingBottom: 32,
      minWidth: 0,
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 32,
      },
    },
    /**
     * Pendiente sin hora: mismo offset que horaSpacer → título a la altura de la bola
     */
    colTextoSinHora: {
      paddingTop: 30,
    },
    /**
     * Etapa solo con título (p. ej. “Brigada en terreno” pendiente):
     * sin bloque de descripción, sumamos altura equivalente (~desc 24 + gap 4)
     * para no pegar la etapa siguiente. Se mantiene el piso de 32.
     */
    colTextoSinCuerpo: {
      paddingBottom: 32 + 28,
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 32 + 28,
      },
    },
    colTextoCorto: {
      paddingBottom: 32,
    },
    colTextoUltimo: {
      paddingBottom: 0,
    },
    /**
     * marginTop 12 no sube la hora; marginBottom -8 + gap 4 → 4px visual hora→título (caja 40)
     */
    hora: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '22px',
      color: '#060709',
      margin: 0,
      marginTop: 12,
      marginBottom: -8,
      padding: 0,
    },
    /**
     * Fecha de notificación del corte futuro: mismo lugar que la hora del paso, peso del Figma.
     */
    horaFecha: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '24px',
      color: '#060709',
      margin: 0,
      marginTop: 12,
      marginBottom: -8,
      padding: 0,
    },
    /**
     * Caja 40 = misma altura del nodo → texto centrado con la bola (sin subir).
     * El “aire” inferior de la caja se compensa en la descripción.
     */
    titulo: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      margin: 0,
      padding: 0,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
    },
    tituloRojo: {
      color: TipoColorLineaAvanceEnum.IMPREVISTO,
    },
    tituloVerde: {
      color: TipoColorLineaAvanceEnum.NORMALIZADO,
    },
    tituloNaranja: {
      color: '#E08A00',
    },
    tituloAzul: {
      color: TipoColorLineaAvanceEnum.FUTURO,
    },
    tituloPendiente: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: '#5A607F',
      margin: 0,
      padding: 0,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
    },
    /**
     * Título en caja 40 centrado: glifo 8–32; con gap 4 el subtítulo quedaría a 12px.
     * marginTop -8 → distancia glifo → subtítulo = 4px (sin subir el título).
     * Textos largos (motivo + comuna) hacen wrap; no forzar nowrap ni scroll horizontal.
     */
    descripcion: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: '#5A607F',
      margin: 0,
      marginTop: -8,
      padding: 0,
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      maxWidth: '100%',
    },
    footer: {
      marginTop: 'auto',
      width: '100%',
      backgroundColor: '#F7F5FF',
      padding: '10px 16px',
      textAlign: 'center',
      boxSizing: 'border-box',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        padding: '8px 16px',
      },
    },
    footerText: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: '#5A607F',
      margin: 0,
    },
  })
);

export default DetalleAvanceStyles;
